Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateAggs = updateAggs;
exports.updateCompositeAggs = updateCompositeAggs;
exports.updateHits = updateHits;
exports.saveQueryToHits = saveQueryToHits;
exports.mockDataForTesting = mockDataForTesting;

var _constants = require('../constants');

var _constants2 = require('../../lib/constants');

function updateAggs(component, aggregations) {
  var append = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: _constants.UPDATE_AGGS,
    component: component,
    aggregations: aggregations,
    append: append
  };
}

function updateCompositeAggs(component, aggregations) {
  var append = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return {
    type: _constants.UPDATE_COMPOSITE_AGGS,
    component: component,
    aggregations: aggregations,
    append: append
  };
}

function updateHits(component, hits, time, hidden) {
  var append = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  return {
    type: _constants.UPDATE_HITS,
    component: component,
    hits: hits.hits,
    total: typeof hits.total === 'object' ? hits.total.value : hits.total,
    hidden: hidden,
    time: time,
    append: append
  };
}

function saveQueryToHits(component, query) {
  return {
    type: _constants2.SET_QUERY_TO_HITS,
    component: component,
    query: query
  };
}

function mockDataForTesting(component, data) {
  return function (dispatch) {
    if (data.hasOwnProperty('aggregations')) {
      dispatch(updateAggs(component, data.aggregations));
    }

    if (data.hasOwnProperty('hits')) {
      dispatch(updateHits(component, data, data.time || undefined));
    }
  };
}